import { DrawerTypes } from '../common/context/IMCContext.interface';

import {
    MessageCenterScreen,
    ParamsType,
} from 'modules/common/components/Navigator/context/NavigatorContext.interface';
import { useIMCContext } from 'modules/IMC/common/context';

/**
 * Available initial screens for the Message Center drawer
 */
/**
 * Hook to manage the IMC (In-app Message Center)
 * Allows opening and closing message and help center drawers from anywhere in the app
 * @returns Functions to control IMC drawers
 */
function useIMC() {
    const {
        openDrawer,
        currOpenDrawer,
        isHelpAgentReady,
        isHelpAgentWidgetOpen,
        openHelpAgentWidget,
        closeHelpAgentWidget,
    } = useIMCContext();

    /**
     * Opens the Message Center drawer
     * @param initialScreen - Name of the initial screen to display
     * @param params - Optional parameters to pass to the screen (e.g., { ticketId: '123' })
     */
    const openMessageCenter = (initialScreen?: MessageCenterScreen, params?: ParamsType) => {
        openDrawer(DrawerTypes.MESSAGE_CENTER, initialScreen, params);
    };

    /**
     * Opens the Help Agent drawer (Decagon chat)
     * @param params - Optional parameters to pass (e.g., { message: 'How do I...' })
     */
    const openHelpAgent = (params?: ParamsType) => {
        openHelpAgentWidget({ message: params?.message, source: params?.source });
    };

    /**
     * Closes any open IMC drawer
     */
    const closeIMC = () => {
        openDrawer(null);
    };

    return {
        openMessageCenter,
        openHelpAgent,
        closeIMC,
        currOpenDrawer,
        isHelpAgentReady,
        // Widget-specific functions
        isHelpAgentWidgetOpen,
        openHelpAgentWidget,
        closeHelpAgentWidget,
    };
}

/** @public */
export default useIMC;
